import InlineSVG from "react-inlinesvg";
import {useRef, useEffect} from "react";
import {css} from "@emotion/react";

const BackToTop = () => {

    const buttonRef = useRef();

    useEffect(()=>{

        const scrollCheck = () => {
            if(buttonRef.current){
                if(window.scrollY > window.innerHeight){
                    buttonRef.current.classList.add('active')
                } else {
                    buttonRef.current.classList.remove('active')
                }
            }
        }

        window.addEventListener('scroll', scrollCheck);
        return ()=>window.removeEventListener('scroll', scrollCheck);

    }, [])

    const buttonStyle = css(`
        position: fixed;
        bottom: 20px;
        right: 20px;
        background: none;
        border: none;
        display:none;
        opacity: 0;
        transition: opacity .5s;
        
        &.active{
            display:block;
            opacity: 1;
        }
       
    `)

    const scrollToTop = () => {
        window.scrollTo(0, 0);
    }

    return (
        <button ref={buttonRef} css={buttonStyle} onClick={scrollToTop}>
            <InlineSVG src={'/images/lac-icons/lac-nav-back-to-top.svg'}/>
        </button>
    )
}

export default BackToTop